import React from 'react';

export const plusIcon = (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
            stroke="#121212"
        />
        <path d="M6.82373 12H17.1767" stroke="#121212" />
        <path d="M12 6.82352L12 17.1765" stroke="#121212" />
    </svg>
);
